module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('span', [_c('i', [_vm._v("“Sir,” the Aide said to the Commanding")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('i', [_vm._v("Officer, “G1, G2, G3, and G4 concur in the opinion that the proposed plan for the operation has an 85 percent chance of success, with acceptable losses.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_c('i', [_vm._v("From this and other missions forty-four of our aircraft are missing.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_c('i', [_vm._v("The National Safety Council predicted yesterday that there would be five hundred and fifty-eight fatal traffic accidents over this forthcoming holiday weekend.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7933a39d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-epigraph.vue
// module id = 72
// module chunks = 0